import React from 'react';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import styles from './GradientButton.module.scss';

interface Props {
	href: string;
	text: string;
	onClick?: () => void;
	className?: string;
}

/** The page's primary CTA — a gradient pill that always leads to a page, so it is a link */
export const GradientButton: React.FC<Props> = ({
	href,
	text,
	onClick,
	className,
}) => (
	<LinkWithQuery
		href={href}
		className={`${styles['button']}${className ? ` ${className}` : ''}`}
		onClick={onClick}
	>
		{text}
	</LinkWithQuery>
);
